// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';

interface SchH2PropertySalesFormDTO { 
  purchaserType: string | null;
  purchaserName: string | null;
  firstName: string | null;
  middleInitial: string | null;
  lastName: string | null;
  purchaserAutoFillId: string | null;
  date: moment.Moment | string | null;
  amount: number;
  explanation: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  phoneNumber: string | null;
  relationshipCode: string | null;
  notDonated: boolean;
  isLivingOrRevocableTrust: boolean;
  trustee: string | null;
  trustor: string | null;
  auditorsNoteId: string | null;
}
const SchH2PropertySalesFormDTO = {
  create: (initValues?: Partial<SchH2PropertySalesFormDTO> | Record<string, unknown> | null) => {
    return Object.assign(
    {
      purchaserType: null,
      purchaserName: null,
      firstName: null,
      middleInitial: null,
      lastName: null,
      purchaserAutoFillId: null,
      date: null,
      amount: 0,
      explanation: null,
      addressLine1: null,
      addressLine2: null,
      city: null,
      state: null,
      zip: null,
      phoneNumber: null,
      relationshipCode: null,
      notDonated: false,
      isLivingOrRevocableTrust: false,
      trustee: null,
      trustor: null,
      auditorsNoteId: null,
    },
    initValues);
  }
};

export default SchH2PropertySalesFormDTO;